import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/senior-couple-looking-house-while-standing-ih-yard_107420-31226.jpg';

function SeniorHousingAssistance() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Senior Housing and Independent Living Assistance" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Senior Housing and Independent Living Assistance</h4>
              <p>
                This sub-department provides support for seniors in finding and maintaining appropriate housing options, ensuring comfort and independence.<br />
                Programs include assistance with senior housing placement, independent living resources, and support for transitioning to assisted living if needed.<br /><br />
                Our goal is to help seniors maintain their independence while ensuring their housing needs are met with dignity and respect.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Senior Housing Placement Assistance</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Resources for Independent Living</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Support for Transitioning to Assisted Living</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to helping seniors find safe, comfortable, and affordable housing options, promoting their independence and quality of life.
              </p>
            </div>
            <div>
              <Link to="/department/senior-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SeniorHousingAssistance;
